// @ts-nocheck

import { OverlaySpineAnimationsIds } from '../types/animations';
import { OverlaySoundIds } from '../types/sounds';

export const OverlaySoundIdByAnimationId = Object.freeze({
  [OverlaySpineAnimationsIds.OL_EAGLE]: OverlaySoundIds.ANTHEM_DE,
  [OverlaySpineAnimationsIds.OL_BULL]: OverlaySoundIds.ANTHEM_ES,
  [OverlaySpineAnimationsIds.OL_ROOSTER]: OverlaySoundIds.ANTHEM_FR,
});
